import React from 'react'
import { ReactComponent as Tick } from "../../assets/components-icons/tick.svg";

export const OrdersItems = ({ item, phone_screen }) => {
    return (
        <div key={item[0].id} className='col-lg-12'>
               <div className='d-flex'>
               <div className="col-lg-6  p-0">
                  <div className='d-flex'>
                      <div className='image-container mt-1'>
                   <img src={item[0].image} alt={item[0].Title}/>
                 </div>
                {!phone_screen && 
                <div className='d-block'>
                   <div>
                     <h5>{item[0].Title}</h5>
                   </div>
                   <div>
                     <span>
                       Toppings:
                       <small className='ml-1'>
                         {item[0].toppings}
                       </small>
                     </span>
                   </div>
                   <div>
                     <span>
                       Crust:
                       <small className='ml-1'>
                         {item[0].get_crust === 'Thick Crust' ? 'Thick Crust(+1.15)' : item[0].get_crust}
                       </small>
                     </span>
                   </div>
                   <div>
                     <span>
                       Size:
                       <small className='ml-1'>
                         {item[0].get_size}
                       </small>
                     </span>
                   </div>
                 </div>
                }
                  </div>
               </div>

               <div className='col-lg-6  d-flex align-items-center justify-content-around'>
                 <div>
                   <h5>
                     <small>$</small>
                      {item[0].get_size === "small" && item[0].price_small}
                      {item[0].get_size === "medium" && item[0].price_medium}
                      {item[0].get_size === "large" && item[0].price_large}
                      {item[0].get_size === "" && item[0].price_small}
                   </h5>
                 </div>
                 <div className='border-around'>
                   <div>
                     <Tick className='svgAll' />
                   </div>
                 </div>
               </div>

               </div>
               { phone_screen &&  

                 <div className='d-block mt-1 mb-1'>
                   <div>
                     <h5>{item[0].Title}</h5>
                   </div>
                   <div>
                     <span>
                       Toppings:
                       <small className='ml-1'>
                         {item[0].toppings}
                       </small>
                     </span>
                   </div>
                   <div>
                     <span>
                       Crust:
                       <small className='ml-1'>
                         {item[0].get_crust === 'Thick Crust' ? 'Thick Crust(+1.15)' : item[0].get_crust}
                       </small>
                     </span>
                   </div>
                   <div>
                     <span>
                       Size:
                       <small className='ml-1'>
                         {item[0].get_size}
                       </small>
                     </span>
                   </div>
                 </div>
                 
                 }
                 <div className='borderAll borderGrey mt-1 mb-1'></div>
             </div>
    )
}
